var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_33217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2726 3.72725C18.0622 1.51685 15.1246 0.300049 11.9998 0.300049C5.54861 0.300049 0.299805 5.54885 0.299805 12C0.299805 18.4512 5.54861 23.7 11.9998 23.7C15.1246 23.7 18.0646 22.4832 20.2726 20.2728C22.483 18.0624 23.6998 15.1248 23.6998 12C23.6998 8.87525 22.4854 5.93765 20.2726 3.72725V3.72725Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0022 9.01679H11.0518C10.999 9.01679 10.951 8.98799 10.9246 8.93759L9.54937 6.40799C9.54217 6.39359 9.53737 6.37679 9.53977 6.35999C9.55177 6.28319 9.61177 6.22559 9.68377 6.22559H19.3726C19.4446 6.22559 19.507 6.28319 19.5166 6.35999C19.519 6.37679 19.5142 6.39359 19.507 6.40799L18.1294 8.93759C18.103 8.98559 18.055 9.01679 18.0022 9.01679V9.01679ZM7.41097 6.37679L10.939 12.3648C10.9654 12.4104 10.9654 12.4656 10.9414 12.5112L9.63337 14.88C9.62617 14.8944 9.61417 14.904 9.60217 14.9112C9.53737 14.9376 9.45817 14.9112 9.42217 14.8488L4.50217 6.50159C4.46617 6.43919 4.48057 6.35999 4.53577 6.31439C4.54777 6.30479 4.56217 6.29999 4.57897 6.29999L7.28617 6.30479C7.33657 6.30479 7.38457 6.33359 7.41097 6.37679V6.37679ZM10.6702 16.896L14.095 10.848C14.1214 10.8024 14.167 10.7736 14.2198 10.7736L16.9246 10.7232C16.939 10.7232 16.9558 10.7256 16.9678 10.7352C17.023 10.7784 17.0398 10.86 17.0038 10.9224L12.2302 19.3536C12.1942 19.416 12.1174 19.4424 12.0502 19.4184C12.0358 19.4136 12.0238 19.4016 12.0166 19.3872L10.6678 17.04C10.6438 16.9968 10.6438 16.9416 10.6702 16.896Z",
    fill: "#3054BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_33217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdl);
export default __webpack_public_path__ + "static/media/vdl.049f8902ebdf82cc104487c4f6c6097e.svg";
export { ForwardRef as ReactComponent };